import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import PaginatedItemsWritten from "../../../../components/tables/paginationResultWritten";
import Repository from "../../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { filterAndSplitJsonWritten } from "../../../../utility/helpers/filterJson";
import { useLocation } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
const ResultWrittenTest = (props) => {
    const location = useLocation();
    const role = useSelector((state) => state.layout.role);
    const testType = location.state?.testType;
    const [array, setArray] = useState(location.state?.array);
    let isData = location.state?.isData;
    let test_id = location.state?.test_id;
    let score = location.state?.score;
    let note_id = location.state?.note_id;
    let noteData = location.state?.noteData;
    let canDoIt = location.state?.canDoIt;
    let getTikets = localStorage.getItem("getTikets");
    let tiketData = JSON.parse(getTikets);
    let notes = tiketData?.test_prompt;

    const [loadingData, setLoadingData] = useState(true);
    const [showProblem, setShowProblem] = useState(false);
    const [resultData, setResultData] = useState("");
    const history = useHistory();

    const [collCount, setCollCount] = useState(0);

    let count = 10;
    let processValue = 10;
    const process = () => {
        if (count < 10) {
            setLoadingData(false);
            count = count + 1;
            processValue = processValue + 10;
            setCollCount(processValue);
            hendleSubmit();
        } else {
            let testType = tiketData.test_type;

            setCollCount(100);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "There is something wrong with the prompt. Please change it and try again.!",
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push({
                        pathname: "/tests",
                        state: {
                            note_id,
                            notes,
                            testType,
                            noteData,
                            canDoIt,
                            test_id,
                        },
                    });
                }
                setLoadingData(true);
            });
        }
    };

    const toaccountingRlashcardPage = () => {
        let testType = tiketData.test_type;
        localStorage.setItem("isCreate", false);
        history.push({
            pathname: "/accountingTest",
            state: {
                array,
                testType,
                note_id,
                tiketData,
                noteData,
                canDoIt,
            },
        });
    };

    function checkTypeTest(count) {
        if (testType.length > 1) {
            return `Written - ${count} Questions`;
        } else {
            return `${testType[0]} - ${count} Questions`;
        }
    }

    const redoTest = async () => {
        localStorage.setItem("isCreate", false);
        history.push({
            pathname: "/accountingTest",
            state: {
                array,
                note_id,
                testType,
                tiketData,
                noteData,
                canDoIt,
                isData,
                test_id,
            },
        });
    };
    const hendleSubmit = async () => {
        setLoadingData(false);
        setTimeout(() => {
            setCollCount(processValue);
        }, 1000);

        const result = await Repository.postRequest(
            `api/test/getChatCompletion`,
            {
                messages: tiketData.test_prompt,
                count: tiketData.no_of_questions,
                testType: "written",
            }
        );
        setResultData(result?.data?.data.getChatCompletionData);

        if (result.status === 200 || result.status === 201) {
            array = filterAndSplitJsonWritten(
                JSON.parse(result.data.data.getChatCompletionData)
            );

            if (array == "error") {
                process();
            } else {
                setCollCount(100);

                setTimeout(() => {
                    toaccountingRlashcardPage();
                }, 2000);
            }
        }
    };
    const jaccardFunc = (text1, text2) => {
        const preprocessText = (text) => {
            if (typeof text !== "string") {
                text = text.toString();
            }
            text = text.toLowerCase(); // Convert text to lowercase
            text = text.replace(/[^\w\s]/g, ""); // Remove punctuation
            return text.split(/\s+/); // Tokenize the text
        };

        const set1 = new Set(preprocessText(text1));
        const set2 = new Set(preprocessText(text2));
        const intersection = [...set1].filter((x) => set2.has(x)).length;
        const union = set1.size + set2.size - intersection;
        const jaccardSimilarity = intersection / union;
        return jaccardSimilarity;
    };
    const retunedScore = () => {
        let similarity;
        let score = 0;
        let data = array.map((item) => {
            if (Array.isArray(item.answer)) {
                similarity = jaccardFunc(
                    item?.answer?.join(", "),
                    item.userAnswer ? item.userAnswer : ""
                );
            } else {
                similarity = jaccardFunc(
                    item.answer,
                    item.userAnswer ? item.userAnswer : ""
                );
            }
            return similarity * 100;
        });
        data.forEach((element) => {
            score = score + element;
        });
        return score / array.length;
    };
    const createResultTest = async () => {
        const result = await Repository.postRequest(
            `api/resultTest/createResultTest`,
            {
                question_count: array.length,
                score: retunedScore(),
                answers: JSON.stringify(array),
                test_id: { test_id: test_id },
            }
        );
    };
    const deleteQuestion = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setArray(array.filter((item) => item.id !== id));
            }
        });
    };
    async function updateTestIsResultState() {
        let result = await Repository.postRequest(`api/test/updateIsResult`, {
            id: test_id,
            is_result: true,
        });
    }
    useEffect(() => {
        updateTestIsResultState();
        createResultTest();
    }, []);
    return loadingData ? (
        showProblem ? (
            <div>
                <Card className="cardSection">
                    <CardBody className="cardBodiDiv">
                        <div>{resultData}</div>
                    </CardBody>
                </Card>
            </div>
        ) : (
            <div>
                <div className="homeCard resultCard mt-4">
                    <div>
                        <div className="resultHeader">
                            <h1>Results</h1>

                            <img
                                src={x_mark}
                                alt="x_mark"
                                onClick={() => {
                                    role == "instructor"
                                        ? history.push({
                                              pathname: "/courses",
                                          })
                                        : history.push({
                                              pathname: "/home",
                                          });
                                }}
                            />
                        </div>
                    </div>

                    <div className="accountingHeaderContent mt-4">
                        <h1>{tiketData?.test_name}</h1>
                    </div>
                    <div className="testType">
                        <div>
                            <span>{checkTypeTest(array.length)}</span>
                        </div>
                    </div>
                    <div className="buttonsDivResult mt-4">
                        <button
                            className="finish"
                            onClick={() => {
                                role == "instructor"
                                    ? history.push({
                                          pathname: "/courses",
                                      })
                                    : history.push({
                                          pathname: "/home",
                                      });
                            }}
                        >
                            Finish
                        </button>
                        <button
                            onClick={() => {
                                redoTest();
                            }}
                        >
                            Re-take
                        </button>
                    </div>

                    <div className="pgItems">
                        <PaginatedItemsWritten
                            itemsPerPage={4}
                            items={array}
                            scoreResult={score}
                            test_id={test_id}
                            isCreate={true}
                            deleteQuestion={deleteQuestion}
                        />
                    </div>
                </div>
            </div>
        )
    ) : (
        <div>
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default ResultWrittenTest;
